import { invalidateRequestTrackingCache } from '../features/request-tracking';
import { clearDashboardCachesForProject } from '../dashboard/dashboardProjectCache';
import { resetTaskStore } from '../stores';
import { clearProjectData } from '../stores/db';

/**
 * Clear in-memory and persisted data for the previous project after a scope switch.
 */
export async function handlePortalScopeChange(
  previousProjectId: string | null | undefined,
): Promise<void> {
  if (previousProjectId?.trim()) {
    try {
      await clearProjectData(previousProjectId);
    } catch (err) {
      console.warn('[Portal] Failed to clear IndexedDB for previous project:', err);
    }
    clearDashboardCachesForProject(previousProjectId);
  }

  resetTaskStore();
  invalidateRequestTrackingCache();
}
